/** Thrown when post-amendment effects were lost after a page refresh. */
export class LaborAmendPostEffectsLostError extends Error {
  constructor() {
    super("Post-amendment effects were lost after a page refresh.");
    this.name = "LaborAmendPostEffectsLostError";
  }
}

export function isLaborAmendPostEffectsLostError(
  error: unknown,
): error is LaborAmendPostEffectsLostError {
  return error instanceof LaborAmendPostEffectsLostError;
}
